import { Fragment } from "react";
import Select from "react-select";
import { Box } from "@mui/material";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { colors } from "../../css components/Style";
import {
  setActiveBrand,
  signInMember,
} from "../../../redux/slices/memberSlice";
import pages from "../../../constants/pages";

const Wrapper = styled(Box)`
  padding: 20px 0px;
`;

const DropdownWrapper = styled(Box)`
  display: flex;
  align-items: flex-start;
  gap: 15px;
`;

let brandType = [
  {
    value: "monetization",
    label: "Consumer",
  },
  {
    value: "promotion",
    label: "Provider",
  },
];
export default function SelectRole({
  currentBrand,
  setCurrentBrand,
  brands,
  setUserDashboardState,
  businessEntityID,
  authToken,
  userID,
  userDashboardState,
  role,
  component = "",
  loadingBrands,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBrandSelect = async (brand) => {
    if (!brand) {
      setCurrentBrand({ ID: null, name: "", type: null });
      sessionStorage.removeItem("activeBrand");
      sessionStorage.removeItem("brandType");
      return;
    }

    function setBrand(ID, name, type) {
      setCurrentBrand({
        ID,
        name,
        type,
        ...(component === "admin" && {
          businessEntityID: brand.businessEntityID,
        }),
      });
      if (type === 3) {
        setUserDashboardState("promotion");
      }
      sessionStorage.setItem("activeBrand", ID);
      sessionStorage.setItem("brandType", type);
    }

    setBrand(brand.ID, brand.brandName, brand.brandType);
    sessionStorage.setItem("role", "NORMAL_USER");
  };

  const NoOptionsMessage = (props) => (
    <div
      style={{
        padding: "10px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        whiteSpace: "nowrap",
      }}
    >
      <span>No brands yet. Please</span>
      <button
        type="button"
        style={{
          position: "relative",
          top: "1.5px",
          background: "transparent",
          border: "none",
          color: colors.growthOSDarkBlue,
          cursor: "pointer",
          fontWeight: "bold",
          padding: 0,
          margin: 0,
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          addNewBrand();
        }}
      >
        Create
      </button>
      <span>a new brand</span>
    </div>
  );

  const customOption = (props) => {
    const { data, innerRef, innerProps, isDisabled, isFocused } = props;

    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "8px 10px",
          cursor: isDisabled ? "not-allowed" : "pointer",
          opacity: isDisabled ? 0.5 : 1,
          color: isDisabled ? "#999" : "#000",
          backgroundColor: isFocused && !isDisabled ? "#f0f8ff" : "transparent",
        }}
      >
        {data.logo ? (
          <img
            src={data.logo}
            alt={data.label}
            style={{
              width: 24,
              height: 24,
              marginRight: 10,
              borderRadius: 4,
              objectFit: "contain",
              filter: isDisabled ? "grayscale(100%)" : "none",
            }}
          />
        ) : (
          <div
            style={{
              width: 24,
              height: 24,
              marginRight: 10,
              backgroundColor: "#ccc",
              borderRadius: 4,
              opacity: isDisabled ? 0.6 : 1,
            }}
          />
        )}
        <span>
          {data.label}
          {isDisabled && (
            <span style={{ marginLeft: 6, fontSize: 12, color: "#aaa" }}></span>
          )}
        </span>
      </div>
    );
  };

  const customSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      {data.logo ? (
        <img
          src={data.logo}
          alt={data.label}
          style={{
            width: 24,
            height: 24,
            marginRight: 8,
            borderRadius: 4,
            objectFit: "contain",
          }}
        />
      ) : (
        <div
          style={{
            width: 24,
            height: 24,
            marginRight: 8,
            backgroundColor: "#ccc",
            borderRadius: 4,
          }}
        />
      )}
      {data.label}
    </div>
  );

  const brandOptions = brands.map((brand) => ({
    value: brand.ID,
    label: brand.brandName,
    logo: brand.logo,
    fullData: brand,
  }));

  async function addNewBrand() {
    sessionStorage.setItem("role", "AGENCY");
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
      })
    );
    dispatch(
      setActiveBrand({
        ID: "",
        about: "",
        brandName: "",
        logo: "",
        languages: [],
        locations: [],
        category: [],
        mau: "",
        onlineStore: "",
        website: "",
        socialMedia: {},
        brandType: "",
      })
    );
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true);
  }

  function setDashboardUser(selected) {
    setUserDashboardState(selected.value);
  }

  return (
    <Fragment>
      <Wrapper
      // sx={{
      //   minHeight: component === "" && "calc(100vh - 300px)",
      // }}
      >
        <DropdownWrapper
          style={{
            marginBottom: component === "" && "40px",
            flexDirection: "column",
          }}
        >
          <Select
            options={brandOptions}
            placeholder="Select brand to continue"
            isSearchable={true}
            isClearable={true}
            isLoading={loadingBrands}
            isOptionDisabled={(option) => option?.fullData?.isVisible === false}
            value={
              brandOptions.find(
                (option) => option.value === currentBrand?.ID
              ) || null
            }
            components={{
              Option: customOption,
              SingleValue: customSingleValue,
              NoOptionsMessage,
            }}
            onChange={(selected) =>
              handleBrandSelect(selected?.fullData || null)
            }
            styles={{
              container: (base) => ({
                ...base,
                width: 300,
              }),
              control: (base, state) => ({
                ...base,
                borderRadius: 12,
                borderColor:
                  state.isFocused || state.hasValue ? colors.purple : "#ccc",
                boxShadow: state.isFocused
                  ? "0 0 0 2px rgba(59, 130, 246, 0.4)"
                  : "none",
                minHeight: 42,
                height: 42,
                // padding: "8px",
                "&:hover": {
                  borderColor: colors.purple,
                },
              }),
              menu: (base) => ({
                ...base,
                width: 300,
              }),
              valueContainer: (base) => ({
                ...base,
                padding: "8px",
                display: "flex",
                alignItems: "center",
              }),
              indicatorsContainer: (base) => ({
                ...base,
                height: 42,
              }),
              input: (base) => ({
                ...base,
                margin: 0,
                paddingBottom: 0,
                paddingTop: 0,
              }),
              singleValue: (base) => ({
                ...base,
                display: "flex",
                alignItems: "center",
                margin: 0,
              }),
            }}
          />

          {currentBrand.type === 3 && (
            <Select
              options={brandType}
              placeholder="Select Role to continue"
              value={
                brandType.find((opt) => opt.value === userDashboardState) ||
                null
              }
              isDisabled={currentBrand.type !== 3}
              components={{
                SingleValue: ({ data }) => <span>{data.label}</span>,
              }}
              onChange={(selected) => {
                setDashboardUser(selected);
              }}
              styles={{
                container: (base) => ({
                  ...base,
                  width: 300,
                }),
                control: (base, state) => ({
                  ...base,
                  borderRadius: 12,
                  borderColor:
                    state.isFocused || state.hasValue ? colors.purple : "#ccc",
                  boxShadow: state.isFocused
                    ? "0 0 0 2px rgba(59, 130, 246, 0.4)"
                    : "none",
                  minHeight: 42,
                  height: 42,
                  "&:hover": {
                    borderColor: colors.purple,
                  },
                }),
                menu: (base) => ({
                  ...base,
                  width: 300,
                }),
                valueContainer: (base) => ({
                  ...base,
                  padding: "8px",
                  display: "flex",
                  alignItems: "center",
                }),
                indicatorsContainer: (base) => ({
                  ...base,
                  height: 42,
                }),
                input: (base) => ({
                  ...base,
                  margin: 0,
                  paddingBottom: 0,
                  paddingTop: 0,
                }),
                singleValue: (base) => ({
                  ...base,
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                }),
              }}
            />
          )}
        </DropdownWrapper>

        {/* {component === "" && (
          <SegmentWrapper>
            <SegmentCards
              role={role}
              component={""}
              userDashboardState={userDashboardState}
              businessEntityID={businessEntityID}
              userID={userID}
              authToken={authToken}
              currentBrand={currentBrand}
            />
          </SegmentWrapper>
        )} */}
      </Wrapper>
    </Fragment>
  );
}
